import React from "react";
import { DeprecatedUISharedButton } from "packages/ui-shared/components/Button/Button";
import { useTrackElementClicked } from "packages/membership/tracking";
import {
  bodyDescription,
  bodyTitle,
  buttonsWrapper,
  nonActiveMembershipSlideLink
} from "../../DiscoveryJourneyModal.css";
import type {
  NoActiveMembershipSlideProps,
  SlideButtonActions
} from "../../types";
import { baseTrackingValues } from "../../types";
import { NoActiveMembershipImage } from "./image-properties/NoActiveMembershipImage";
import { Link } from "../../../../../../components/Navigation/Shared/Link";

type Props = SlideButtonActions & NoActiveMembershipSlideProps;

export const NoActiveMembershipSlide: React.FC<
  NoActiveMembershipSlideProps
> = ({ navigateToJoinNowPage }) => {
  return (
    <div>
      <NoActiveMembershipImage />
      <h2 className={bodyTitle}>No Active Membership</h2>
      <p className={bodyDescription}>
        Sorry, you don't currently have access to our new Member Perks, but
        don't worry! You can unlock access by{" "}
        <Link
          href="/bp/join/join-beauty-pie#"
          onClick={() => {
            navigateToJoinNowPage?.();
          }}
          className={nonActiveMembershipSlideLink}
        >
          joining as a Beauty Pie Member
        </Link>
      </p>
    </div>
  );
};

export const NoActiveMembershipSlideCTA: React.FC<Props> = ({
  backToPreviousSlide,
  navigateToJoinNowPage
}) => {
  const { elementClicked } = useTrackElementClicked(baseTrackingValues);

  const nextButtonAction = () => {
    navigateToJoinNowPage?.();
    elementClicked({
      details: "join_now",
      locationDetails: "no_active_membership_slide",
      contentUrl: window
        ? `${window.location.origin}/bp/join/join-beauty-pie`
        : ""
    });
  };

  const previousButtonAction = () => {
    backToPreviousSlide?.();
    elementClicked({
      details: "back",
      locationDetails: "no_active_membership_slide"
    });
  };

  return (
    <div className={buttonsWrapper}>
      <DeprecatedUISharedButton
        variant="tertiary"
        type="button"
        fullWidth
        handleClick={previousButtonAction}
        ariaLabel="Back"
      >
        Back
      </DeprecatedUISharedButton>{" "}
      <DeprecatedUISharedButton
        variant="primary"
        type="button"
        fullWidth
        handleClick={nextButtonAction}
        ariaLabel="Join Now"
      >
        Join Now
      </DeprecatedUISharedButton>
    </div>
  );
};
